<template>
   <div class="header">
      <div class="mobkast-icon-cell">
         <img class="mobkast-icon" src="../../assets/mobkast-logo-icon.png" @click="navigateToHome">
      </div>
      <div class="nav-title">
         <img src="../../assets/mobkast-logo-text.png" class="text-logo" width="108px">
      </div>      
      <div class="menu-container">
      </div>
   </div>
</template>

<script>
export default {
   name: 'Header',
   props: ['title'],
   data () {
      return {

      }
   },
   methods: {
      preventMouseDown: (e) => {},
      navigateToHome: (ev) => {
         window.location = '/';
      }
   }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.header {
   display: grid;
   grid-template-areas: "icon title menu";
   grid-template-columns: 6rem auto 6rem;
   border-bottom: solid 1px grey;
}

.mobkast-icon {
   width: 42px;
   cursor: pointer;
}

.mobkast-icon-cell {
   grid-area: icon;
   height: 60px;
   display: flex;
   justify-content: center;
   align-items: center;
}
.nav-title {
   grid-area: title;
   height: 60px;
   display:flex;
   justify-content:center;
   align-items:center;   
}

.nav-title h1 {
   font-size: 1.6em;
}

.menu-container {
   grid-area: menu;
   height: 60px;
   display: flex;
   justify-content: flex-end;
   align-items: center;
}

@media screen and (max-width: 500px) {
   .header {
      grid-template-columns: 5rem auto 5rem;
   }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue